import React, { useEffect, useState } from 'react';
import { TableAdmin } from '../../../../../components/TableAdmin';
import { FlexDirectionWrapper, MainContent, SubTitle, } from '../../../../../components/StyledComponents';
import { DevolutivaPadraoService } from "../../../services/devolutivaPadraoService";
import { numberLocale } from "../../../../../utils/mask";
import { SearchInputAdmin } from "../../../../../components/SearchInputAdmin";
import FiltersModel from "../../../filters.model";
import { removeEmpty, truncateString } from "../../../../../utils/utils";
import { useApp } from "../../../../../context/app";


export const Gerenciar = () => {
    const {setRenderIncludeScreen, setManageItem} = useApp();
    const [data, setData] = useState([]);
    
    const {
        inputSearchValue,
        setInputSearchValue,
        paginationFilters,
        handleOrderClick,
        onLinesPerPageChange,
        handlePageChange,
        handleInputPageChange,
        isLoading,
        setIsLoading,
    } = FiltersModel()
    
    const getData = async () => {
        try {
            const bodyParams = removeEmpty({oqueVoceProcura: inputSearchValue});
            
            const response = await DevolutivaPadraoService.findAll(
                paginationFilters,
                bodyParams,
            );
            setIsLoading(false);
            setData(response);
        } catch (e) {
            setIsLoading(false);
            setData([]);
        }
    };
    
    
    useEffect(() => {
        setIsLoading(true);
        setData([]);
        getData();
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationFilters, inputSearchValue]);
    
    const tableColumns = [
        // {
        //     field: "dataCriacao",
        //     id: "dataCriacao",
        //     label: "Data",
        //     minWidth: 10
        // },
        {
            field: "descricao",
            id: "descricao",
            label: "Tema",
            align: "left",
            columnStyle: {
                overflowWrap: 'break-word',
                width: 300,
                wordBreak: 'break-word',
                whiteSpace: 'break-spaces'
            },
        },
        {
            field: "basico",
            id: "basico",
            label: "Básico",
            align: "left",
            handleField: (text) => <p title={text}>{truncateString(text, 200)}</p>,
            columnStyle: {
                overflowWrap: 'break-word',
                width: 300,
                wordBreak: 'break-word',
                whiteSpace: 'break-spaces'
            },
        },
        {
            field: "intermediario",
            id: "intermediario",
            label: "Intermediário",
            align: "left",
            handleField: (text) => <p title={text}>{truncateString(text, 200)}</p>,
            columnStyle: {
                overflowWrap: 'break-word',
                width: 300,
                wordBreak: 'break-word',
                whiteSpace: 'break-spaces'
            },
        },
        {
            field: "avancado",
            id: "avancado",
            label: "Avançado",
            align: "left",
            handleField: (text) => <p title={text}>{truncateString(text, 200)}</p>,
            columnStyle: {
                overflowWrap: 'break-word',
                width: 300,
                wordBreak: 'break-word',
                whiteSpace: 'break-spaces'
            },
        },
        {
            field: "actions",
            id: "actions",
            label: "Status",
            minWidth: 150,
            align: 'left',
        },
    ];
    
    const handleEditClick = (item) => {
        setManageItem({
            type: 'edit',
            data: item,
        });
        setRenderIncludeScreen(true);
    };
    
    
    return (
        <MainContent>
            <SubTitle>
                <>
                    <h3>Gerenciar</h3>
                    <SearchInputAdmin
                        value={inputSearchValue}
                        onChange={setInputSearchValue}
                    />
                </>
            </SubTitle>
            
            <FlexDirectionWrapper
                style={{justifyContent: 'space-between', marginTop: '12px'}}
            >
                <div>
                    <p style={{fontWeight: 'bold', color: '#0061C6'}}>
                        {numberLocale(data?.totalElements)}{' '}
                        <strong className="find-results">
                            {' '}
                            {data?.totalElements ? 'resultados encontrados' : ''}{' '}
                        </strong>
                    </p>
                </div>
            
            </FlexDirectionWrapper>
            
            <TableAdmin
                {...{
                    data,
                    paginationFilters,
                    isLoading,
                    onLinesPerPageChange,
                    handleEditClick,
                    handleOrderClick,
                    
                }}
                sentEntireObjectToEdit
                sentEntireObjectToCopy
                columnAction={'actions'}
                paginationFilters={paginationFilters}
                linesPerPageFilters={paginationFilters?.linesPerPage}
                pagination={true}
                totalPages={data?.totalPages}
                columns={tableColumns}
                isLoading={isLoading}
                tableColor={'#0061C6'}
                lineColor={'rgba(0, 97, 198, 0.1)'}
                onLinesPerPageChange={onLinesPerPageChange}
                onPagePreviousChange={handlePageChange}
                onPageNextChange={handlePageChange}
                handleOrderClick={handleOrderClick}
                onInputPageChange={handleInputPageChange}
            />
        </MainContent>
    );
};
